import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";

import { useImpersonation } from "../../../../hook/useImpersonation";

const ImpersonationConfirmModal = ({ data, onCancel }) => {
  const { handleImpersonate, isApiLoading } = useImpersonation();

  const handleImpersonateClick = async () => {
    await handleImpersonate(data._id);
  };

  return (
    <Box>
      <Typography
        id="confirmation-modal-title"
        variant="h6"
        component="h2"
        gutterBottom
      >
        Confirm Impersonation
      </Typography>
      <Typography id="confirmation-modal-description" sx={{ mt: 2, mb: 3 }}>
        {`Are you sure you want to impersonate ${
          data?.instituteName || ""
        }? This action will grant you their permissions.`}
      </Typography>
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button
          variant="outlined"
          sx={{ color: "red" }}
          color="warning"
          onClick={onCancel}
          disabled={isApiLoading}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={isApiLoading}
          onClick={handleImpersonateClick}
          sx={{ ml: 2 }}
        >
          Confirm
          {isApiLoading && (
            <CircularProgress
              size={24}
              sx={{ color: "white", marginRight: 0, marginLeft: 0.5 }}
            />
          )}
        </Button>
      </Stack>
    </Box>
  );
};

export default ImpersonationConfirmModal;
